import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderError } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type ReportOrderErrorProps = {
  formData: IOrderError;
} & RequestsProps;

export type UseReportOrderErrorReturn = {
  create: (props: ReportOrderErrorProps) => Promise<void>;
} & UseLoadingReturn;

const useReportOrderError = (): UseReportOrderErrorReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderError>({
    operation: (formData) => orderStatusService.reportError(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useReportOrderError;
